import {COLLECTION_EXAM_MODULE} from '../examModule/constants';
import {SUBCOLLECTION_STUDY} from './constants';

export function getStudyCollectionPath(examModuleId: string): string {
  return `${COLLECTION_EXAM_MODULE}/${examModuleId}/${SUBCOLLECTION_STUDY}`;
}
